import { api } from "..";

import { QueryProps } from "@/types/Api";
import { User } from "@/types/User";

export interface GetSubDealersPlayersQueryParams {
  subDealerIds?: number[];
  subDealerUsernames?: string[];
}

export const getSubDealersPlayers = async (
  props: QueryProps<GetSubDealersPlayersQueryParams>
): Promise<User[]> => {
  const res = await api.client.get("/users-new", {
    signal: props.signal,
  });
  const users: User[] = res.data;

  const { subDealerIds, subDealerUsernames } = props.params ?? {};

  if (subDealerUsernames && subDealerUsernames.length > 0) {
    const set = new Set(subDealerUsernames);
    return users.filter((u) => u.subDealer && set.has(u.subDealer.username));
  }

  if (subDealerIds && subDealerIds.length > 0) {
    const set = new Set(subDealerIds);
    return users.filter((u) => u.subDealer && set.has(u.subDealer.id));
  }

  return users;
};
